import api from "@/lib/api";

export async function openBillingPortal(lookupKey) {
  const { data } = await api.post("/payments/portal", {
    origin_url: window.location.origin, lookup_key: lookupKey,
  });
  window.location.assign(data.portal_url);
}

export async function startPlanCheckout(lookupKey, couponCode) {
  try {
    const { data } = await api.post("/payments/checkout", {
      lookup_key: lookupKey, origin_url: window.location.origin, coupon_code: couponCode,
    });
    window.location.assign(data.checkout_url);
  } catch (error) {
    if (error.response?.status === 409 && error.response?.data?.detail?.includes("existing subscription")) {
      await openBillingPortal(lookupKey);
      return;
    }
    throw error;
  }
}